import styled from "styled-components";
import { Link } from "react-router-dom";
import { GRIFFLE_TYPE, GRIFFLE_RADIUS } from "src/modules/griffle/griffleTheme";

export const StyledGriffleBookCard = styled.div`
  background: var(--color-surface);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.18s, transform 0.18s;
  font-family: var(--font-body);
  /* Book-like border: slightly stronger left edge to suggest a spine */
  border: 1px solid var(--color-border);
  border-left: 4px solid var(--color-primary) 55;

  &:hover {
    box-shadow: var(--shadow-card-hover);
    transform: translateY(-3px);
    border-left-color: var(--color-primary);
  }

  &.selected {
    border-color: var(--color-primary);
    border-left-color: var(--color-primary);
    box-shadow: 0 0 0 2px var(--color-primary) 33;
  }

  /* ── Cover area: capped height, full image visible ── */
  .card-cover {
    width: 100%;
    height: 160px;
    overflow: hidden;
    background: #f0f4ec;
    flex-shrink: 0;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      /* contain keeps the full cover visible, no cropping */
      object-fit: contain;
      object-position: center center;
      display: block;
    }

    /* Subtle inner shadow at bottom to blend cover into card body */
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 24px;
      background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.05));
      pointer-events: none;
    }

    .cover-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--color-primary);
      opacity: 0.25;
      background: #edf4e8;
    }
  }

  /* ── Text body ── */
  .card-body {
    padding: 10px 12px 6px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  .card-title {
    font-family: var(--font-heading);
    font-weight: ${GRIFFLE_TYPE.weightBold};
    font-size: 13px;
    color: var(--color-ink);
    line-height: 1.3;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .card-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 2px;
  }

  .card-meta-row {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: ${GRIFFLE_TYPE.small};
    color: var(--color-ink-muted);
    line-height: 1.4;

    .meta-icon {
      width: 12px;
      height: 12px;
      opacity: 0.45;
      flex-shrink: 0;
    }

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .card-reading-level {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #edf7e4;
    border: 1px solid var(--color-primary) 44;
    border-radius: ${GRIFFLE_RADIUS.badge};
    padding: 2px 8px;
    font-size: ${GRIFFLE_TYPE.small};
    font-weight: ${GRIFFLE_TYPE.weightSemi};
    color: var(--color-primary);
    width: fit-content;
    margin-top: 4px;
  }

  /* ── CTA footer ── */
  .card-footer {
    padding: 0 12px 12px;
    margin-top: auto;
  }
`;

export const GriffleCardButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: 34px;
  background: var(--color-primary);
  color: #fff;
  border-radius: var(--radius-button);
  font-family: var(--font-body);
  font-size: ${GRIFFLE_TYPE.body};
  font-weight: ${GRIFFLE_TYPE.weightSemi};
  text-decoration: none;
  transition: background 0.15s, transform 0.1s;

  &:hover {
    background: var(--color-primary-dark);
    color: #fff;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &.disabled,
  &[aria-disabled="true"] {
    opacity: 0.5;
    pointer-events: none;
  }
`;
